import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.9994 0.333496L12.803 1.40495L12.8152 1.42105L12.8641 1.48577C12.9074 1.54287 12.9716 1.6272 13.0543 1.73489C13.2197 1.9503 13.4589 2.25886 13.7522 2.62946C14.3398 3.37166 15.1414 4.35805 16.002 5.34166C16.8669 6.33009 17.7725 7.2938 18.5701 8.00275C18.9702 8.35841 19.3197 8.62884 19.6056 8.80475C19.8444 8.95172 19.9681 8.98815 19.9988 8.99719L19.9994 8.00016H21.9994V9.00016C21.9994 9.40657 21.8955 9.91078 21.5428 10.3308C21.1647 10.781 20.6138 11.0002 19.9994 11.0002L3.99945 11.0002C3.3849 11.0002 2.83443 10.7809 2.4563 10.3313C2.10375 9.91214 1.9991 9.40898 1.9976 9.00387L1.9939 8.00388L3.99388 7.99646L3.99759 8.99646L3.9976 8.99792L4.00009 8.99719C4.03076 8.98816 4.1545 8.95172 4.39332 8.80476C4.67919 8.62884 5.02872 8.35841 5.42884 8.00275C6.22641 7.2938 7.132 6.33009 7.99687 5.34166C8.85753 4.35805 9.65908 3.37166 10.2467 2.62946C10.54 2.25886 10.7792 1.9503 10.9446 1.73489C11.0273 1.6272 11.0915 1.54287 11.1348 1.48577L11.1837 1.42105L11.1959 1.40495L11.9994 0.333496Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.99945 13.0002L3.99945 20.0002H1.99945L1.99945 22.0002H8.99976V18.9995C8.99976 17.3427 10.3429 15.9995 11.9998 15.9995C13.6566 15.9995 14.9998 17.3427 14.9998 18.9995V22.0002H21.9994V20.0002H19.9994V13.0002L3.99945 13.0002Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0001 17.9998C11.4478 17.9998 11.0001 18.4476 11.0001 18.9998V21.9998H13.0001V18.9998C13.0001 18.4476 12.5523 17.9998 12.0001 17.9998Z"}}]};

const ArchitectureHuiStyleFilled = Vue.extend<IconProps>({
  name: 'ArchitectureHuiStyleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'architecture-hui-style-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ArchitectureHuiStyleFilled;
